import { render, staticRenderFns } from "./PointTicket.vue?vue&type=template&id=02e44082&scoped=true"
import script from "./PointTicket.vue?vue&type=script&lang=js"
export * from "./PointTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e44082",
  null
  
)

export default component.exports